<template>
    <div class="form-group">
        <label class="form-control-label" :for="internalId">{{ internalLabel }}</label>
        <textarea
            :id="internalId"
            class="form-control"
            :class="error ? 'is-invalid' : ''"
            :placeholder="internalLabel"
            :name="name"
            rows="6"
            v-bind:value="value"
            @input="$emit('input', $event.target.value)"
            :autofocus="autofocus"
            ref="input"
            ></textarea>

        <div class="invalid-feedback" v-if="error">
            {{ error }}
        </div>
    </div>
</template>

<script>
export default {
    name: "Textarea",
    props: {
        name: { type: String, required: true },
        id: { type: String|null|undefined, default: '', required: false },
        label: { type: String, default: '', required: false },
        error: { type: String, default: '', required: false },
        value: { type: String, default: '', required: false },
        autofocus: { type: Boolean, default: false, required: false },
    },
    data() {
        return {
            internalId: this.$props.id.length ? this.$props.id : this.$props.name,
            internalLabel: this.$props.label.length ? this.$props.label : this.$props.name,
        };
    },
}
</script>